import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExitPopupLight = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M780.809 243.625c-16.64-16.64-43.52-16.64-60.16 0l-208.64 208.215-208.639-208.641c-16.64-16.64-43.52-16.64-60.16 0s-16.64 43.52 0 60.16l208.64 208.641-208.64 208.64c-16.64 16.64-16.64 43.52 0 60.16s43.52 16.64 60.16 0l208.639-208.64 208.64 208.64c16.64 16.64 43.52 16.64 60.16 0s16.64-43.52 0-60.16l-208.64-208.64 208.64-208.641c16.213-16.213 16.213-43.52 0-59.733v0z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgExitPopupLight);
export default ForwardRef;
